import { message } from "@version2/ui-package";
import type { MessageInstance } from "@version2/ui-package";

type MessageMethod =
  | "open"
  | "success"
  | "error"
  | "info"
  | "warning"
  | "loading";

type PendingMessageCall = {
  method: MessageMethod;
  args: unknown[];
};

const pendingQueue: PendingMessageCall[] = [];
const proxied = new Set<MessageMethod>();
let currentInstance: MessageInstance | null = null;

const proxyMethod = (method: MessageMethod) => {
  if (proxied.has(method)) {
    return;
  }

  proxied.add(method);

  (message as any)[method] = (...args: unknown[]) => {
    if (currentInstance) {
      return (currentInstance as any)[method](...args);
    }

    pendingQueue.push({ method, args });
    return undefined;
  };
};

const methods: MessageMethod[] = [
  "open",
  "success",
  "info",
  "warning",
  "error",
  "loading",
];

methods.forEach(proxyMethod);

export const bindMessageInstance = (instance: MessageInstance) => {
  currentInstance = instance;

  while (pendingQueue.length > 0 && currentInstance) {
    const { method, args } = pendingQueue.shift() as PendingMessageCall;
    (currentInstance as any)[method](...args);
  }
};
